import React from 'react'

const MapIcon = (
  <svg
    aria-hidden="true"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33.3333 5.83334H6.66659C3.45 5.83334 0.833252 8.45009 0.833252 11.6667V33.3333C0.833252 36.5499 3.45 39.1667 6.66659 39.1667H33.3333C36.5498 39.1667 39.1666 36.5499 39.1666 33.3333V11.6667C39.1666 8.45009 36.5498 5.83334 33.3333 5.83334Z"
      fill="#494949"
    />
    <path
      d="M33.3333 10.8333H6.66659C6.20642 10.8333 5.83325 11.2065 5.83325 11.6667V33.3333C5.83325 33.7935 6.20642 34.1667 6.66659 34.1667H33.3333C33.7934 34.1667 34.1666 33.7935 34.1666 33.3333V11.6667C34.1666 11.2065 33.7934 10.8333 33.3333 10.8333Z"
      fill="#EAD8C5"
    />
    <path
      d="M28.3333 17.3991L23.3333 22.3991L19.2675 18.3333L26.7675 10.8333H23.2323L10.8333 23.2324L5.83325 18.2324V21.7676L9.06567 25L5.83325 28.2324V31.7676L10.8333 26.7676L18.2323 34.1667H23.4342L32.4999 25.1009L34.1666 26.7676V23.2324L28.3333 17.3991ZM20.8333 33.2324L12.6008 25L17.4999 20.1009L23.3333 25.9343L28.3333 20.9343L30.7323 23.3333L20.8333 33.2324Z"
      fill="white"
    />
    <path
      d="M18.4342 10.8333H14.899L11.6666 14.0658L8.43417 10.8333H6.66659C6.20642 10.8333 5.83325 11.2065 5.83325 11.6667V11.7676L11.6666 17.6009L18.4342 10.8333Z"
      fill="white"
    />
    <path
      d="M19.9999 0.833344C15.4939 0.833344 10.8333 4.26226 10.8333 10C10.8333 15.424 19.0583 23.7757 19.4083 24.1288C19.5649 24.2863 19.7778 24.375 19.9999 24.375C20.2221 24.375 20.4349 24.2863 20.5916 24.1288C20.9415 23.7757 29.1666 15.424 29.1666 10C29.1666 4.26226 24.5059 0.833344 19.9999 0.833344Z"
      fill="#E86C60"
    />
    <path
      d="M19.9999 11.6667C20.9204 11.6667 21.6666 10.9205 21.6666 10C21.6666 9.07954 20.9204 8.33334 19.9999 8.33334C19.0794 8.33334 18.3333 9.07954 18.3333 10C18.3333 10.9205 19.0794 11.6667 19.9999 11.6667Z"
      fill="white"
    />
  </svg>
)

export default MapIcon
